import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';
import { FeatureModule } from '../features/module';
import { OrderModule } from '../order/module';
import { EventOrderList } from './components/order-list/component';
import { EventApiService } from './services/event-api-service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    FeatureModule,
    OrderModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [EventOrderList],
  providers: [EventApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class EventModule {}
